import { IsBoolean, IsEmail, IsIn, IsObject, IsOptional, IsString } from "class-validator"
import { TransformToTrimmedStringOrNull } from "../../utils/transformations"

export type GenderType = "male" | "female" | "other" | "nonbinary"
export const GenderValues = ["male", "female", "other", "nonbinary"]
/**
 * This DTO is the expected request body for the postNewUser endpoint.
 */
export default class UserPostIn {
  @IsOptional()
  @IsObject()
  userSource: object

  @IsString()
  @TransformToTrimmedStringOrNull()
  fullName: string

  @IsEmail()
  @TransformToTrimmedStringOrNull()
  email: string

  @IsOptional()
  @IsString()
  @TransformToTrimmedStringOrNull()
  phoneNumber: string

  @IsOptional()
  @IsIn(GenderValues)
  @TransformToTrimmedStringOrNull()
  gender: GenderType

  @IsOptional()
  @IsString()
  @TransformToTrimmedStringOrNull()
  zipCode: string

  @IsOptional()
  @IsBoolean()
  smsConsent?: boolean
}
